var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title},on:{"click-left":_vm.goBack}},[_c('span',{staticClass:"left",attrs:{"slot":"left"},slot:"left"},[_c('img',{attrs:{"src":require("@/assets/left.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }